(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marketplace-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      bindCtaWobble();

      document.querySelectorAll('.marketplace-pdp__mini-rev-viewport').forEach(initMarquee);

      initStickyAtc();
      initVariantPicker();
      initQuantityStepper();
      initThumbnailGallery();
      initMemberStrip();
      swapHeaderLogo();
      initRecs();
      initRecsAddToCart();

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(fitAllPriceLines, 150);
      });

      hideSimpleeBlock();
    }

    function initRecs() {
      var wraps = document.querySelectorAll('[data-marketplace-recs]');
      if (!wraps.length) return;
      var grids = document.querySelectorAll('[data-marketplace-recs-grid]');
      if (!grids.length) return;
      var first = wraps[0];
      var pid = first.dataset.productId;
      var isMember = first.dataset.member === '1';
      var disc = parseInt(first.dataset.discount, 10) || 0;
      var limit = parseInt(first.dataset.limit, 10) || 8;

      function money(cents) {
        return '$' + (cents / 100).toFixed(2);
      }

      function sizedImg(url) {
        if (!url) return '';
        return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=400';
      }

      function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }

      function firstVariant(p) {
        if (p.variants && p.variants.length) {
          for (var i = 0; i < p.variants.length; i++) {
            if (p.variants[i].available) return p.variants[i];
          }
          return p.variants[0];
        }
        return null;
      }

      function card(p) {
        var priceHtml;
        if (isMember) {
          var sv = Math.floor(p.price * disc / 100);
          var mp = p.price - sv;
          priceHtml = '<span class="marketplace-pdp__rec-was">' + money(p.price) + '</span>' +
            '<div class="marketplace-pdp__rec-priceline" data-rec-fit>' +
            '<span class="marketplace-pdp__rec-now">' + money(mp) + '</span>' +
            '<span class="marketplace-pdp__rec-now-label">- YOUR MEMBERS PRICE!</span>' +
            '</div>' +
            '<span class="marketplace-pdp__rec-save marketplace-pdp__rec-save--full">MEMBERS SAVE ' + money(sv) + '!</span>' +
            '<span class="marketplace-pdp__rec-save marketplace-pdp__rec-save--short" data-rec-fit>SAVE ' + money(sv) + '</span>';
        } else {
          priceHtml = '<span class="marketplace-pdp__rec-now--plain">' + money(p.price) + '</span>';
        }
        var img = p.featured_image
          ? '<img class="marketplace-pdp__rec-img" src="' + esc(sizedImg(p.featured_image)) + '" alt="' + esc(p.title) + '" loading="lazy" width="200" height="200">'
          : '';
        var v = firstVariant(p);
        var vid = v ? v.id : '';
        var avail = v ? !!v.available : false;
        var atc = '<button type="button" class="marketplace-pdp__rec-atc" data-rec-atc data-variant-id="' + esc(vid) + '"' + (avail ? '' : ' disabled') + '>' + (avail ? 'GRAB!' : 'SOLD OUT') + '</button>';
        return '<div class="marketplace-pdp__rec-card">' +
          '<a class="marketplace-pdp__rec-media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true"><div class="marketplace-pdp__rec-imgwrap">' + img + '</div></a>' +
          '<div class="marketplace-pdp__rec-body">' +
          (p.vendor ? '<div class="marketplace-pdp__rec-vendor">' + esc(p.vendor) + '</div>' : '') +
          '<a class="marketplace-pdp__rec-name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="marketplace-pdp__rec-price">' + priceHtml + '</div>' +
          atc +
          '</div></div>';
      }

      function load(intent) {
        return fetch('/recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&intent=' + intent + '&limit=' + limit, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (d) { return (d && d.products) || []; })
          .catch(function () { return []; });
      }

      var productId = parseInt(pid, 10);

      function getCartProductIds() {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : { items: [] }; })
          .then(function (c) { return (c.items || []).map(function (i) { return i.product_id; }); })
          .catch(function () { return []; });
      }

      // Build the visible set: curated complementary -> related (relevance),
      // topped up from the same-collection pool, excluding the current product
      // and anything already in the cart, deduped, limited. Guarantees a full
      // row even when Shopify drops in-cart items from its recommendations.
      function renderRecs() {
        var pool = window.MARKETPLACE_RECS_POOL || [];
        return Promise.all([
          getCartProductIds(),
          load('complementary').then(function (it) { return (it && it.length) ? it : load('related'); })
        ]).then(function (res) {
          var cartIds = res[0] || [];
          var apiItems = res[1] || [];
          var seen = {};
          var out = [];
          function consider(p) {
            if (!p || !p.id) return;
            if (p.id === productId) return;
            if (seen[p.id]) return;
            if (cartIds.indexOf(p.id) > -1) return;
            if (p.available === false || !p.price) return;
            seen[p.id] = 1;
            out.push(p);
          }
          apiItems.forEach(consider);
          pool.forEach(consider);
          if (!out.length) return;
          var html = out.slice(0, limit).map(card).join('');
          grids.forEach(function (g) { g.innerHTML = html; });
          refreshRecsUI();
        });
      }

      // Fit the server-rendered fallback immediately, then refine.
      refreshRecsUI();
      renderRecs();

      // Re-run on Back (bfcache restore) so a product just added to the cart
      // is swapped out for a fresh one.
      window.addEventListener('pageshow', function (e) {
        if (e.persisted) renderRecs();
      });
    }

    // Keep the member price + "YOUR MEMBERS PRICE!" on one line by shrinking
    // the line's font-size until it fits the card. Hidden instances (the
    // opposite-viewport copy) have clientWidth 0 and are skipped.
    // Shrink a group of one-line elements to a SINGLE common font size — the
    // smallest any member needs — so the same element lines up at the same
    // height across all three cards. (Per-element sizing rode the long-price
    // card higher than the others.)
    function fitGroup(selector) {
      var els = Array.prototype.slice.call(document.querySelectorAll(selector))
        .filter(function (el) { return el.clientWidth > 0; });
      if (!els.length) return;
      var min = 11;
      var sizes = els.map(function (el) {
        el.style.fontSize = '';
        var size = parseFloat(window.getComputedStyle(el).fontSize) || 20;
        var guard = 0;
        el.style.fontSize = size + 'px';
        while (el.scrollWidth > el.clientWidth + 0.5 && size > min && guard < 60) {
          size -= 1;
          el.style.fontSize = size + 'px';
          guard++;
        }
        return size;
      });
      var common = Math.min.apply(null, sizes);
      els.forEach(function (el) { el.style.fontSize = common + 'px'; });
    }

    function fitAllPriceLines() {
      fitGroup('.marketplace-pdp__rec-priceline[data-rec-fit]');
      fitGroup('.marketplace-pdp__rec-save--short[data-rec-fit]');
    }

    function bindCtaWobble() {
      document.querySelectorAll('.marketplace-pdp__atc, .marketplace-pdp__rec-atc').forEach(function (btn) {
        if (btn.dataset.marketplaceWobbleInit) return;
        btn.dataset.marketplaceWobbleInit = '1';

        function wobble() {
          if (btn.disabled) return;
          btn.classList.remove('marketplace-pdp__atc--wobbling');
          void btn.offsetWidth;
          btn.classList.add('marketplace-pdp__atc--wobbling');
        }

        btn.addEventListener('mouseenter', wobble);
        btn.addEventListener('touchstart', wobble, { passive: true });
        btn.addEventListener('animationend', function (e) {
          if (e.animationName === 'marketplace-cta-wobble') {
            btn.classList.remove('marketplace-pdp__atc--wobbling');
          }
        });

        // Only the main ATC auto-wobbles when scrolled into view. Rec cards
        // wobble on hover only, to avoid 3+ buttons wobbling at once.
        if (btn.classList.contains('marketplace-pdp__atc') && 'IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting && !btn.dataset.marketplaceFirstWobbled) {
                btn.dataset.marketplaceFirstWobbled = '1';
                setTimeout(wobble, 200);
              }
            });
          }, { threshold: 0.6 });
          io.observe(btn);
        }
      });
    }

    function refreshRecsUI() {
      fitAllPriceLines();
      bindCtaWobble();
    }

    // Add-to-cart for recommendation cards. Delegated so dynamically swapped
    // cards work too. Uses the theme's Dawn cart drawer (renderContents + open),
    // falling back to a cart-icon-bubble refresh.
    function initRecsAddToCart() {
      var section = document.querySelector('.marketplace-pdp');
      if (!section) return;
      section.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-rec-atc]');
        if (!btn || btn.disabled || btn.dataset.adding) return;
        e.preventDefault();
        var vid = btn.dataset.variantId;
        if (!vid) return;

        btn.dataset.adding = '1';
        var orig = btn.textContent;
        btn.classList.add('marketplace-pdp__rec-atc--loading');
        btn.textContent = 'ADDING...';

        var cartDrawer = document.querySelector('cart-drawer');
        var sections = ['cart-drawer', 'cart-icon-bubble'];
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          try { sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; }); } catch (err) {}
        }

        function reset() {
          btn.dataset.adding = '';
          btn.classList.remove('marketplace-pdp__rec-atc--loading');
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
          body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }], sections: sections, sections_url: window.location.pathname })
        }).then(function (r) { return r.json(); }).then(function (res) {
          reset();
          if (res && res.status && res.status !== 200) {
            btn.textContent = 'UNAVAILABLE';
            setTimeout(function () { btn.textContent = orig; }, 1800);
            return;
          }
          btn.classList.add('marketplace-pdp__rec-atc--added');
          btn.textContent = 'ADDED ✓';
          setTimeout(function () {
            btn.classList.remove('marketplace-pdp__rec-atc--added');
            btn.textContent = orig;
          }, 1800);

          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            try { cartDrawer.classList.remove('is-empty'); cartDrawer.renderContents(res); } catch (err) {}
          } else if (res && res.sections && res.sections['cart-icon-bubble']) {
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble) { try { bubble.innerHTML = res.sections['cart-icon-bubble']; } catch (err) {} }
          }
        }).catch(function () {
          reset();
          btn.textContent = orig;
        });
      });
    }

    function swapHeaderLogo() {
      var section = document.querySelector('.marketplace-pdp');
      if (!section) return;
      var desktopSrc = section.dataset.marketplaceLogoDesktop;
      var mobileSrc = section.dataset.marketplaceLogoMobile;
      if (!desktopSrc && !mobileSrc) return;

      function pick() {
        return window.matchMedia('(max-width: 768px)').matches ? (mobileSrc || desktopSrc) : (desktopSrc || mobileSrc);
      }

      var headers = document.querySelectorAll('header, [class*="header" i]');
      var swapped = false;
      headers.forEach(function (h) {
        if (h.closest('.marketplace-pdp')) return;
        var imgs = h.querySelectorAll('img');
        imgs.forEach(function (img) {
          if (img.dataset.marketplaceLogoSwapped) return;
          var src = (img.src || '') + ' ' + (img.alt || '');
          if (src.toLowerCase().indexOf('i4wd') >= 0 || (h.querySelector('a[href="/"]') && h.querySelector('a[href="/"]').contains(img))) {
            img.dataset.marketplaceLogoSwapped = '1';
            img.dataset.marketplaceLogoOriginalSrc = img.src;
            img.dataset.marketplaceLogoOriginalSrcset = img.srcset || '';
            img.src = pick();
            img.srcset = '';
            img.style.maxHeight = '52px';
            img.style.width = 'auto';
            img.style.objectFit = 'contain';
            swapped = true;
          }
        });
      });

      if (swapped) {
        window.addEventListener('resize', function () {
          document.querySelectorAll('img[data-marketplace-logo-swapped]').forEach(function (img) {
            img.src = pick();
          });
        });
      }
    }

    function initVariantPicker() {
      var product = window.MARKETPLACE_PRODUCT || {};
      var select = document.querySelector('[data-marketplace-variant-select]');
      var sellingPlanInput = document.querySelector('[data-marketplace-selling-plan]');
      var priceEl = document.querySelector('[data-marketplace-price]');
      var compareEl = document.querySelector('[data-marketplace-compare-price]');
      var skuEl = document.querySelector('[data-marketplace-sku]');
      var heroImg = document.querySelector('[data-marketplace-hero]');
      var memberPriceEl = document.querySelector('[data-marketplace-member-price]');
      var stickyPrice = document.querySelector('.marketplace-pdp__sticky-price');
      var atcBtn = document.querySelector('[data-marketplace-atc-btn]');

      if (atcBtn) atcBtn.dataset.activeLabel = atcBtn.textContent.trim();

      if (!select || select.tagName !== 'SELECT') return;

      function formatMoney(cents) {
        var dollars = cents / 100;
        return '$' + dollars.toFixed(dollars % 1 === 0 ? 0 : 2);
      }

      function findMediaMatch(option1, option2, option3) {
        if (!product.media || !product.media.length) return null;
        var opts = [option1, option2, option3];
        var searchTerms = [];
        for (var oi = 0; oi < opts.length; oi++) {
          var ov = opts[oi];
          if (!ov) continue;
          var words = String(ov).toLowerCase().split(/[\s/_-]+/);
          for (var wi = 0; wi < words.length; wi++) {
            var w = words[wi].replace(/[^a-z0-9]/g, '');
            if (w.length >= 3) searchTerms.push(w);
          }
        }
        for (var ti = 0; ti < searchTerms.length; ti++) {
          var term = searchTerms[ti];
          for (var mi = 0; mi < product.media.length; mi++) {
            var m = product.media[mi];
            var hay = ((m.src || '') + ' ' + (m.alt || '')).toLowerCase();
            if (hay.indexOf(term) >= 0) return m.src;
          }
        }
        return null;
      }

      var priceBlock = document.querySelector('[data-marketplace-price-block]');
      var isActiveMember = priceBlock && priceBlock.dataset.isMember === 'true';
      var memberDiscountPercent = (product.memberDiscountPercent != null) ? product.memberDiscountPercent : 15;

      function applySelected() {
        var opt = select.options[select.selectedIndex];
        if (!opt) return;
        var price = parseInt(opt.dataset.price, 10) || 0;
        var compareAt = parseInt(opt.dataset.comparePrice, 10) || 0;
        var available = opt.dataset.available === 'true';
        var sku = opt.dataset.sku || '';
        var image = opt.dataset.image || '';
        var sellingPlan = opt.dataset.sellingPlan || '';
        var option1 = opt.dataset.option1 || '';
        var option2 = opt.dataset.option2 || '';
        var option3 = opt.dataset.option3 || '';
        var variantId = opt.value;
        var memberPrice = price - Math.floor(price * memberDiscountPercent / 100);

        if (sellingPlanInput && sellingPlan) sellingPlanInput.value = sellingPlan;

        if (priceEl) {
          priceEl.textContent = formatMoney(isActiveMember ? memberPrice : price);
        }
        if (compareEl) {
          if (isActiveMember) {
            compareEl.textContent = formatMoney(price);
            compareEl.style.display = '';
          } else if (compareAt > price) {
            compareEl.textContent = formatMoney(compareAt);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (skuEl) skuEl.textContent = sku;
        if (memberPriceEl) {
          memberPriceEl.textContent = formatMoney(memberPrice);
        }
        var discountAmountEl = document.querySelector('[data-marketplace-discount-amount]');
        if (discountAmountEl) {
          discountAmountEl.textContent = formatMoney(price - memberPrice);
        }
        if (stickyPrice) {
          if (isActiveMember) {
            stickyPrice.innerHTML = '<s class="marketplace-pdp__sticky-rrp">' + formatMoney(price) + '</s> <span class="marketplace-pdp__sticky-member">' + formatMoney(memberPrice) + '</span>';
          } else {
            stickyPrice.textContent = formatMoney(price);
          }
        }

        if (heroImg) {
          var nextImage = findMediaMatch(option1, option2, option3) || image;
          if (nextImage) {
            heroImg.src = nextImage;
            heroImg.srcset = '';
          }
        }

        if (atcBtn) {
          if (available) {
            atcBtn.disabled = false;
            atcBtn.textContent = atcBtn.dataset.activeLabel || 'ADD TO CART';
          } else {
            atcBtn.disabled = true;
            atcBtn.textContent = 'Sold out';
          }
        }

        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          history.replaceState({}, '', url);
        } catch (e) {}
      }

      select.addEventListener('change', applySelected);
      select.addEventListener('input', applySelected);

      // Sync hero image / price / SKU to the currently selected option on load.
      // Covers Back navigation: the browser restores the select to the chosen
      // variant (and the URL keeps ?variant=), but the hero is server-rendered
      // as the featured image, so without this it would show the wrong colour.
      applySelected();
      window.addEventListener('pageshow', function () { applySelected(); });

      var stickyBtn = document.querySelector('.marketplace-pdp__sticky-btn');
      var form = document.querySelector('.marketplace-pdp__form');
      if (stickyBtn && atcBtn) {
        stickyBtn.addEventListener('click', function () {
          if (form && typeof form.requestSubmit === 'function') {
            form.requestSubmit(atcBtn);
          } else {
            atcBtn.click();
          }
        });
      }
    }

    function initQuantityStepper() {
      var input = document.querySelector('[data-marketplace-qty-input]');
      var dec = document.querySelector('[data-marketplace-qty-dec]');
      var inc = document.querySelector('[data-marketplace-qty-inc]');
      if (!input) return;
      if (dec) dec.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        if (v > 1) input.value = v - 1;
      });
      if (inc) inc.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = v + 1;
      });
    }

    function initThumbnailGallery() {
      var thumbs = document.querySelectorAll('[data-marketplace-thumb]');
      var hero = document.querySelector('[data-marketplace-hero]');
      if (!thumbs.length || !hero) return;
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var src = t.dataset.fullSrc;
          if (src) hero.src = src;
          thumbs.forEach(function (x) { x.classList.remove('marketplace-pdp__thumb--active'); });
          t.classList.add('marketplace-pdp__thumb--active');
        });
      });
    }

    function initMemberStrip() {
      // Liquid now renders the correct strip variant directly based on
      // active-membership detection. Nothing to toggle here. Function
      // kept as a no-op so the call site stays clean.
    }

    function initStickyAtc() {
      var sticky = document.querySelector('.marketplace-pdp__sticky-atc');
      var mainAtc = document.querySelector('.marketplace-pdp__atc');
      if (!sticky || !mainAtc) return;
      if (sticky.dataset.marketplaceStickyInit) return;
      sticky.dataset.marketplaceStickyInit = '1';

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            sticky.classList.remove('marketplace-pdp__sticky-atc--visible');
            sticky.setAttribute('aria-hidden', 'true');
          } else {
            sticky.classList.add('marketplace-pdp__sticky-atc--visible');
            sticky.setAttribute('aria-hidden', 'false');
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });

      observer.observe(mainAtc);

      var btn = sticky.querySelector('.marketplace-pdp__sticky-btn');
      if (btn) {
        btn.addEventListener('click', function () {
          mainAtc.click();
        });
      }
    }

    function initMarquee(viewport) {
      if (viewport.dataset.marketplaceMarqueeInit) return;
      viewport.dataset.marketplaceMarqueeInit = '1';

      var track = viewport.querySelector('.marketplace-pdp__mini-rev-track');
      if (!track) return;

      var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var offset = 0;
      var speed = 0.55;
      var isDragging = false;
      var isHovering = false;
      var dragStartX = 0;
      var dragStartOffset = 0;
      var lastTime = performance.now();
      var totalWidth = 0;

      function recalc() {
        totalWidth = track.scrollWidth / 2;
      }

      recalc();
      window.addEventListener('resize', recalc);

      function tick(now) {
        var dt = Math.min(now - lastTime, 50);
        lastTime = now;
        if (!isDragging && !isHovering && !prefersReducedMotion && totalWidth > 0) {
          offset -= speed * (dt / 16.67);
          while (offset <= -totalWidth) {
            offset += totalWidth;
          }
        }
        track.style.transform = 'translateX(' + offset + 'px)';
        requestAnimationFrame(tick);
      }

      function onDragStart(clientX) {
        isDragging = true;
        dragStartX = clientX;
        dragStartOffset = offset;
        viewport.classList.add('marketplace-pdp__mini-rev-viewport--grabbing');
      }

      function onDragMove(clientX) {
        if (!isDragging || totalWidth === 0) return;
        offset = dragStartOffset + (clientX - dragStartX);
        while (offset <= -totalWidth) offset += totalWidth;
        while (offset > 0) offset -= totalWidth;
      }

      function onDragEnd() {
        if (!isDragging) return;
        isDragging = false;
        viewport.classList.remove('marketplace-pdp__mini-rev-viewport--grabbing');
      }

      viewport.addEventListener('mouseenter', function () { isHovering = true; });
      viewport.addEventListener('mouseleave', function () { isHovering = false; onDragEnd(); });
      viewport.addEventListener('mousedown', function (e) {
        e.preventDefault();
        onDragStart(e.clientX);
      });
      document.addEventListener('mousemove', function (e) { onDragMove(e.clientX); });
      document.addEventListener('mouseup', onDragEnd);

      viewport.addEventListener('touchstart', function (e) {
        if (e.touches && e.touches[0]) onDragStart(e.touches[0].clientX);
      }, { passive: true });
      viewport.addEventListener('touchmove', function (e) {
        if (e.touches && e.touches[0]) onDragMove(e.touches[0].clientX);
      }, { passive: true });
      viewport.addEventListener('touchend', onDragEnd);
      viewport.addEventListener('touchcancel', onDragEnd);

      requestAnimationFrame(tick);
    }

    function findSimpleeLabel() {
      var tags = ['label', 'legend', 'span', 'div', 'p', 'strong', 'b', 'h2', 'h3', 'h4', 'h5', 'h6'];
      for (var i = 0; i < tags.length; i++) {
        var els = document.querySelectorAll(tags[i]);
        for (var j = 0; j < els.length; j++) {
          var el = els[j];
          if (el.children.length > 0) continue;
          var text = (el.textContent || '').trim().toLowerCase().replace(/[:\s]+$/, '');
          if (text === 'membership length' || text === 'membership type' || text === 'membership plan') {
            return el;
          }
        }
      }
      return null;
    }

    function hideSimpleeBlock() {
      if (document.querySelector('[data-marketplace-simplee-hidden]')) return;

      var candidates = [];
      var nodes = document.querySelectorAll('div, section, fieldset, article, aside');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.dataset && el.dataset.marketplaceSimpleeHidden) continue;
        if (el.closest && el.closest('.marketplace-pdp')) continue;
        if (el.querySelector && el.querySelector('.marketplace-pdp__atc')) continue;

        var text = (el.textContent || '').toLowerCase();
        if (text.length > 3000) continue;

        var hits = 0;
        if (text.indexOf('membership length') >= 0) hits++;
        if (text.indexOf('billed monthly') >= 0) hits++;
        if (text.indexOf('renewal') >= 0) hits++;
        if (text.indexOf('membership type') >= 0) hits++;
        if (text.indexOf('cancel anytime') >= 0 && text.indexOf('entries per month') >= 0) hits++;
        if (hits >= 2) candidates.push({ el: el, hits: hits, len: text.length });
      }

      if (!candidates.length) return;

      candidates.sort(function (a, b) {
        if (b.hits !== a.hits) return b.hits - a.hits;
        return a.len - b.len;
      });

      var target = candidates[0].el;

      if (target.offsetHeight > window.innerHeight * 0.7) return;

      var parent = target.parentElement;
      if (parent) {
        var parentText = (parent.textContent || '').toLowerCase();
        if (parentText.indexOf('membership length') >= 0 &&
            (target.textContent || '').toLowerCase().indexOf('membership length') < 0 &&
            !parent.closest('.marketplace-pdp') &&
            !parent.querySelector('.marketplace-pdp__atc') &&
            parent.offsetHeight < window.innerHeight * 0.7) {
          target = parent;
        }
      }

      target.style.setProperty('display', 'none', 'important');
      target.dataset.marketplaceSimpleeHidden = '1';
    }


    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    var observer = new MutationObserver(function () {
      hideSimpleeBlock();
    });
    var startObserver = function () {
      if (document.body) {
        observer.observe(document.body, { childList: true, subtree: true });
      } else {
        setTimeout(startObserver, 50);
      }
    };
    startObserver();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["patched-membership-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.patched-pdp__atc').forEach(function (btn) {
        if (btn.dataset.patchedWobbleInit) return;
        btn.dataset.patchedWobbleInit = '1';

        function wobble() {
          btn.classList.remove('patched-pdp__atc--wobbling');
          void btn.offsetWidth;
          btn.classList.add('patched-pdp__atc--wobbling');
        }

        btn.addEventListener('mouseenter', wobble);
        btn.addEventListener('touchstart', wobble, { passive: true });
        btn.addEventListener('animationend', function (e) {
          if (e.animationName === 'patched-cta-wobble') {
            btn.classList.remove('patched-pdp__atc--wobbling');
          }
        });

        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting && !btn.dataset.patchedFirstWobbled) {
                btn.dataset.patchedFirstWobbled = '1';
                setTimeout(wobble, 200);
              }
            });
          }, { threshold: 0.6 });
          io.observe(btn);
        } else {
          setTimeout(wobble, 400);
        }
      });

      document.querySelectorAll('.patched-pdp__mini-rev-viewport').forEach(initMarquee);

      initStickyAtc();
      initTierSwitching();

      hideSimpleeBlock();
    }

    function initStickyAtc() {
      var sticky = document.querySelector('.patched-pdp__sticky-atc');
      var mainAtc = document.querySelector('.patched-pdp__atc');
      if (!sticky || !mainAtc) return;
      if (sticky.dataset.patchedStickyInit) return;
      sticky.dataset.patchedStickyInit = '1';

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            sticky.classList.remove('patched-pdp__sticky-atc--visible');
            sticky.setAttribute('aria-hidden', 'true');
          } else {
            sticky.classList.add('patched-pdp__sticky-atc--visible');
            sticky.setAttribute('aria-hidden', 'false');
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });

      observer.observe(mainAtc);

      var btn = sticky.querySelector('.patched-pdp__sticky-btn');
      if (btn) {
        btn.addEventListener('click', function () {
          mainAtc.click();
        });
      }
    }

    function initMarquee(viewport) {
      if (viewport.dataset.patchedMarqueeInit) return;
      viewport.dataset.patchedMarqueeInit = '1';

      var track = viewport.querySelector('.patched-pdp__mini-rev-track');
      if (!track) return;

      var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var offset = 0;
      var speed = 0.55;
      var isDragging = false;
      var isHovering = false;
      var dragStartX = 0;
      var dragStartOffset = 0;
      var lastTime = performance.now();
      var totalWidth = 0;

      function recalc() {
        totalWidth = track.scrollWidth / 2;
      }

      recalc();
      window.addEventListener('resize', recalc);

      function tick(now) {
        var dt = Math.min(now - lastTime, 50);
        lastTime = now;
        if (!isDragging && !isHovering && !prefersReducedMotion && totalWidth > 0) {
          offset -= speed * (dt / 16.67);
          while (offset <= -totalWidth) {
            offset += totalWidth;
          }
        }
        track.style.transform = 'translateX(' + offset + 'px)';
        requestAnimationFrame(tick);
      }

      function onDragStart(clientX) {
        isDragging = true;
        dragStartX = clientX;
        dragStartOffset = offset;
        viewport.classList.add('patched-pdp__mini-rev-viewport--grabbing');
      }

      function onDragMove(clientX) {
        if (!isDragging || totalWidth === 0) return;
        offset = dragStartOffset + (clientX - dragStartX);
        while (offset <= -totalWidth) offset += totalWidth;
        while (offset > 0) offset -= totalWidth;
      }

      function onDragEnd() {
        if (!isDragging) return;
        isDragging = false;
        viewport.classList.remove('patched-pdp__mini-rev-viewport--grabbing');
      }

      viewport.addEventListener('mouseenter', function () { isHovering = true; });
      viewport.addEventListener('mouseleave', function () { isHovering = false; onDragEnd(); });
      viewport.addEventListener('mousedown', function (e) {
        e.preventDefault();
        onDragStart(e.clientX);
      });
      document.addEventListener('mousemove', function (e) { onDragMove(e.clientX); });
      document.addEventListener('mouseup', onDragEnd);

      viewport.addEventListener('touchstart', function (e) {
        if (e.touches && e.touches[0]) onDragStart(e.touches[0].clientX);
      }, { passive: true });
      viewport.addEventListener('touchmove', function (e) {
        if (e.touches && e.touches[0]) onDragMove(e.touches[0].clientX);
      }, { passive: true });
      viewport.addEventListener('touchend', onDragEnd);
      viewport.addEventListener('touchcancel', onDragEnd);

      requestAnimationFrame(tick);
    }

    function findSimpleeLabel() {
      var tags = ['label', 'legend', 'span', 'div', 'p', 'strong', 'b', 'h2', 'h3', 'h4', 'h5', 'h6'];
      for (var i = 0; i < tags.length; i++) {
        var els = document.querySelectorAll(tags[i]);
        for (var j = 0; j < els.length; j++) {
          var el = els[j];
          if (el.children.length > 0) continue;
          var text = (el.textContent || '').trim().toLowerCase().replace(/[:\s]+$/, '');
          if (text === 'membership length' || text === 'membership type' || text === 'membership plan') {
            return el;
          }
        }
      }
      return null;
    }

    function hideSimpleeBlock() {
      if (document.querySelector('[data-patched-simplee-hidden]')) return;

      var candidates = [];
      var nodes = document.querySelectorAll('div, section, fieldset, article, aside');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.dataset && el.dataset.patchedSimpleeHidden) continue;
        if (el.closest && el.closest('.patched-pdp')) continue;
        if (el.querySelector && el.querySelector('.patched-pdp__atc')) continue;

        var text = (el.textContent || '').toLowerCase();
        if (text.length > 3000) continue;

        var hits = 0;
        if (text.indexOf('membership length') >= 0) hits++;
        if (text.indexOf('billed monthly') >= 0) hits++;
        if (text.indexOf('renewal') >= 0) hits++;
        if (text.indexOf('membership type') >= 0) hits++;
        if (text.indexOf('cancel anytime') >= 0 && text.indexOf('entries per month') >= 0) hits++;
        if (hits >= 2) candidates.push({ el: el, hits: hits, len: text.length });
      }

      if (!candidates.length) return;

      candidates.sort(function (a, b) {
        if (b.hits !== a.hits) return b.hits - a.hits;
        return a.len - b.len;
      });

      var target = candidates[0].el;

      if (target.offsetHeight > window.innerHeight * 0.7) return;

      var parent = target.parentElement;
      if (parent) {
        var parentText = (parent.textContent || '').toLowerCase();
        if (parentText.indexOf('membership length') >= 0 &&
            (target.textContent || '').toLowerCase().indexOf('membership length') < 0 &&
            !parent.closest('.patched-pdp') &&
            !parent.querySelector('.patched-pdp__atc') &&
            parent.offsetHeight < window.innerHeight * 0.7) {
          target = parent;
        }
      }

      target.style.setProperty('display', 'none', 'important');
      target.dataset.patchedSimpleeHidden = '1';
    }

    var TIER_DATA = {
      'patched-4h-monthly-membership': { short: '4H', entries: '50', weekly: '$2.30' },
      'patched-4lo-monthly-membership': { short: '4LO', entries: '120', weekly: '$4.61' },
      'patched-twin-locked-monthly-membership': { short: 'Twin Locked', entries: '300', weekly: '$11.54' },
      'patched-sgt-at-arms-monthly-membership': { short: 'Sgt. At Arms', entries: '600', weekly: '$23.09' }
    };

    function handleFromUrl(url) {
      try {
        var path = new URL(url, window.location.origin).pathname;
        var parts = path.split('/').filter(Boolean);
        return parts[parts.length - 1] || null;
      } catch (e) {
        return null;
      }
    }

    function applyTier(handle, productData) {
      var tier = TIER_DATA[handle];
      if (!tier) return;

      var titleEl = document.querySelector('.patched-pdp__title');
      if (titleEl && productData) titleEl.textContent = productData.title;

      var breadcrumbTitle = document.querySelector('[data-patched-breadcrumb-title]');
      if (breadcrumbTitle && productData) {
        breadcrumbTitle.textContent = (productData.title || '').toLowerCase();
      }

      if (productData) {
        var renewalBefore = document.querySelector('[data-patched-renewal-title-before]');
        var renewalAfter = document.querySelector('[data-patched-renewal-title-after]');
        var parts = (productData.title || '').split('Monthly');
        if (renewalBefore) renewalBefore.textContent = (parts[0] || '').trim();
        if (renewalAfter) renewalAfter.textContent = parts.length > 1 ? (parts[1] || '').trim() : '';
      }

      var priceEl = document.querySelector('.patched-pdp__price');
      if (priceEl && productData) {
        priceEl.textContent = '$' + Math.round(productData.price / 100);
      }

      var entriesBadge = document.querySelector('[data-patched-entries]');
      if (entriesBadge) entriesBadge.textContent = '+' + tier.entries + ' entries every month';

      var weeklyValueEl = document.querySelector('[data-patched-weekly-value]');
      if (weeklyValueEl && tier.weekly) weeklyValueEl.textContent = tier.weekly;

      var tierNameSpan = document.querySelector('[data-patched-tier-name]');
      if (tierNameSpan) tierNameSpan.textContent = tier.short;

      document.querySelectorAll('[data-benefit-template]').forEach(function (li) {
        var tmpl = li.dataset.benefitTemplate || '';
        li.textContent = tmpl.split('[entries]').join(tier.entries);
      });

      var renewalPrice = document.querySelector('[data-patched-renewal-price]');
      if (renewalPrice && productData) {
        renewalPrice.textContent = '$' + Math.round(productData.price / 100);
      }

      var heroImg = document.querySelector('.patched-pdp__hero-img');
      if (heroImg && productData && productData.featured_image) {
        heroImg.src = productData.featured_image;
        heroImg.srcset = '';
      }

      var variantInput = document.querySelector('[data-patched-variant-id]');
      if (variantInput && productData && productData.variants && productData.variants[0]) {
        variantInput.value = productData.variants[0].id;
      }

      var sellingPlanInput = document.querySelector('[data-patched-selling-plan]');
      if (productData && productData.sellingPlanId) {
        if (sellingPlanInput) {
          sellingPlanInput.value = productData.sellingPlanId;
        } else {
          var form = document.querySelector('.patched-pdp__form');
          if (form) {
            var freshInput = document.createElement('input');
            freshInput.type = 'hidden';
            freshInput.name = 'selling_plan';
            freshInput.value = productData.sellingPlanId;
            freshInput.setAttribute('data-patched-selling-plan', '');
            form.appendChild(freshInput);
          }
        }
      }

      var stickyTitle = document.querySelector('.patched-pdp__sticky-title');
      if (stickyTitle) stickyTitle.textContent = 'Patched ' + tier.short;
      var stickyPrice = document.querySelector('.patched-pdp__sticky-price');
      if (stickyPrice && productData) {
        var cadenceEl = document.querySelector('.patched-pdp__cadence');
        var suffix = cadenceEl ? cadenceEl.textContent : '/month';
        stickyPrice.textContent = '$' + Math.round(productData.price / 100) + suffix;
      }

      document.querySelectorAll('.patched-pdp__tier-card').forEach(function (c) {
        var cardHandle = handleFromUrl(c.getAttribute('href'));
        if (cardHandle === handle) {
          c.classList.add('patched-pdp__tier-card--active');
          c.setAttribute('aria-current', 'true');
        } else {
          c.classList.remove('patched-pdp__tier-card--active');
          c.removeAttribute('aria-current');
        }
      });

      if (productData) document.title = productData.title;
    }

    function initTierSwitching() {
      var cards = document.querySelectorAll('.patched-pdp__tier-card');
      if (!cards.length) return;

      cards.forEach(function (card) {
        if (card.dataset.patchedTierInit) return;
        card.dataset.patchedTierInit = '1';

        card.addEventListener('click', function (e) {
          var href = card.getAttribute('href');
          var handle = handleFromUrl(href);
          if (!handle || !TIER_DATA[handle]) return;
          if (handle === handleFromUrl(window.location.href)) {
            e.preventDefault();
            return;
          }
          e.preventDefault();

          var data = buildProductDataFromPreload(handle);
          if (data) {
            applyTier(handle, data);
            history.pushState({ patchedHandle: handle }, '', href);
          } else {
            fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
              .then(function (r) { return r.json(); })
              .then(function (fetched) {
                applyTier(handle, fetched);
                history.pushState({ patchedHandle: handle }, '', href);
              })
              .catch(function () {
                window.location.href = href;
              });
          }
        });
      });

      window.addEventListener('popstate', function () {
        var handle = handleFromUrl(window.location.href);
        if (handle && TIER_DATA[handle]) {
          var data = buildProductDataFromPreload(handle);
          if (data) {
            applyTier(handle, data);
          } else {
            fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
              .then(function (r) { return r.json(); })
              .then(function (fetched) { applyTier(handle, fetched); })
              .catch(function () {});
          }
        }
      });
    }

    function buildProductDataFromPreload(handle) {
      var pre = window.PATCHED_TIER_DATA && window.PATCHED_TIER_DATA[handle];
      if (!pre) return null;
      return {
        title: pre.title,
        price: pre.priceCents,
        featured_image: pre.image,
        variants: [{ id: pre.variantId }],
        sellingPlanId: pre.sellingPlanId
      };
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    var observer = new MutationObserver(function () {
      hideSimpleeBlock();
    });
    var startObserver = function () {
      if (document.body) {
        observer.observe(document.body, { childList: true, subtree: true });
      } else {
        setTimeout(startObserver, 50);
      }
    };
    startObserver();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unpatched-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.unpatched-pdp__atc').forEach(function (btn) {
        if (btn.dataset.unpatchedWobbleInit) return;
        btn.dataset.unpatchedWobbleInit = '1';

        function wobble() {
          btn.classList.remove('unpatched-pdp__atc--wobbling');
          void btn.offsetWidth;
          btn.classList.add('unpatched-pdp__atc--wobbling');
        }

        btn.addEventListener('mouseenter', wobble);
        btn.addEventListener('touchstart', wobble, { passive: true });
        btn.addEventListener('animationend', function (e) {
          if (e.animationName === 'unpatched-cta-wobble') {
            btn.classList.remove('unpatched-pdp__atc--wobbling');
          }
        });

        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting && !btn.dataset.unpatchedFirstWobbled) {
                btn.dataset.unpatchedFirstWobbled = '1';
                setTimeout(wobble, 200);
              }
            });
          }, { threshold: 0.6 });
          io.observe(btn);
        } else {
          setTimeout(wobble, 400);
        }
      });

      document.querySelectorAll('.unpatched-pdp__mini-rev-viewport').forEach(initMarquee);

      initStickyAtc();
      initTierSwitching();

      hideSimpleeBlock();
    }

    function initStickyAtc() {
      var sticky = document.querySelector('.unpatched-pdp__sticky-atc');
      var mainAtc = document.querySelector('.unpatched-pdp__atc');
      if (!sticky || !mainAtc) return;
      if (sticky.dataset.unpatchedStickyInit) return;
      sticky.dataset.unpatchedStickyInit = '1';

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            sticky.classList.remove('unpatched-pdp__sticky-atc--visible');
            sticky.setAttribute('aria-hidden', 'true');
          } else {
            sticky.classList.add('unpatched-pdp__sticky-atc--visible');
            sticky.setAttribute('aria-hidden', 'false');
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });

      observer.observe(mainAtc);

      var btn = sticky.querySelector('.unpatched-pdp__sticky-btn');
      if (btn) {
        btn.addEventListener('click', function () {
          mainAtc.click();
        });
      }
    }

    function initMarquee(viewport) {
      if (viewport.dataset.unpatchedMarqueeInit) return;
      viewport.dataset.unpatchedMarqueeInit = '1';

      var track = viewport.querySelector('.unpatched-pdp__mini-rev-track');
      if (!track) return;

      var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var offset = 0;
      var speed = 0.55;
      var isDragging = false;
      var isHovering = false;
      var dragStartX = 0;
      var dragStartOffset = 0;
      var lastTime = performance.now();
      var totalWidth = 0;

      function recalc() {
        totalWidth = track.scrollWidth / 2;
      }

      recalc();
      window.addEventListener('resize', recalc);

      function tick(now) {
        var dt = Math.min(now - lastTime, 50);
        lastTime = now;
        if (!isDragging && !isHovering && !prefersReducedMotion && totalWidth > 0) {
          offset -= speed * (dt / 16.67);
          while (offset <= -totalWidth) {
            offset += totalWidth;
          }
        }
        track.style.transform = 'translateX(' + offset + 'px)';
        requestAnimationFrame(tick);
      }

      function onDragStart(clientX) {
        isDragging = true;
        dragStartX = clientX;
        dragStartOffset = offset;
        viewport.classList.add('unpatched-pdp__mini-rev-viewport--grabbing');
      }

      function onDragMove(clientX) {
        if (!isDragging || totalWidth === 0) return;
        offset = dragStartOffset + (clientX - dragStartX);
        while (offset <= -totalWidth) offset += totalWidth;
        while (offset > 0) offset -= totalWidth;
      }

      function onDragEnd() {
        if (!isDragging) return;
        isDragging = false;
        viewport.classList.remove('unpatched-pdp__mini-rev-viewport--grabbing');
      }

      viewport.addEventListener('mouseenter', function () { isHovering = true; });
      viewport.addEventListener('mouseleave', function () { isHovering = false; onDragEnd(); });
      viewport.addEventListener('mousedown', function (e) {
        e.preventDefault();
        onDragStart(e.clientX);
      });
      document.addEventListener('mousemove', function (e) { onDragMove(e.clientX); });
      document.addEventListener('mouseup', onDragEnd);

      viewport.addEventListener('touchstart', function (e) {
        if (e.touches && e.touches[0]) onDragStart(e.touches[0].clientX);
      }, { passive: true });
      viewport.addEventListener('touchmove', function (e) {
        if (e.touches && e.touches[0]) onDragMove(e.touches[0].clientX);
      }, { passive: true });
      viewport.addEventListener('touchend', onDragEnd);
      viewport.addEventListener('touchcancel', onDragEnd);

      requestAnimationFrame(tick);
    }

    function findSimpleeLabel() {
      var tags = ['label', 'legend', 'span', 'div', 'p', 'strong', 'b', 'h2', 'h3', 'h4', 'h5', 'h6'];
      for (var i = 0; i < tags.length; i++) {
        var els = document.querySelectorAll(tags[i]);
        for (var j = 0; j < els.length; j++) {
          var el = els[j];
          if (el.children.length > 0) continue;
          var text = (el.textContent || '').trim().toLowerCase().replace(/[:\s]+$/, '');
          if (text === 'membership length' || text === 'membership type' || text === 'membership plan' || text === 'access period' || text === 'access length') {
            return el;
          }
        }
      }
      return null;
    }

    function hideSimpleeBlock() {
      if (document.querySelector('[data-unpatched-simplee-hidden]')) return;

      var candidates = [];
      var nodes = document.querySelectorAll('div, section, fieldset, article, aside');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.dataset && el.dataset.unpatchedSimpleeHidden) continue;
        if (el.closest && el.closest('.unpatched-pdp')) continue;
        if (el.querySelector && el.querySelector('.unpatched-pdp__atc')) continue;

        var text = (el.textContent || '').toLowerCase();
        if (text.length > 3000) continue;

        var hits = 0;
        if (text.indexOf('membership length') >= 0) hits++;
        if (text.indexOf('billed monthly') >= 0) hits++;
        if (text.indexOf('renewal') >= 0) hits++;
        if (text.indexOf('membership type') >= 0) hits++;
        if (text.indexOf('cancel anytime') >= 0 && text.indexOf('entries per month') >= 0) hits++;
        if (text.indexOf('one time payment') >= 0) hits++;
        if (text.indexOf('access to members benefits') >= 0) hits++;
        if (text.indexOf('check emails after purchase') >= 0) hits++;
        if (hits >= 2) candidates.push({ el: el, hits: hits, len: text.length });
      }

      if (!candidates.length) return;

      candidates.sort(function (a, b) {
        if (b.hits !== a.hits) return b.hits - a.hits;
        return a.len - b.len;
      });

      var target = candidates[0].el;

      if (target.offsetHeight > window.innerHeight * 0.7) return;

      var parent = target.parentElement;
      if (parent) {
        var parentText = (parent.textContent || '').toLowerCase();
        if (parentText.indexOf('membership length') >= 0 &&
            (target.textContent || '').toLowerCase().indexOf('membership length') < 0 &&
            !parent.closest('.unpatched-pdp') &&
            !parent.querySelector('.unpatched-pdp__atc') &&
            parent.offsetHeight < window.innerHeight * 0.7) {
          target = parent;
        }
      }

      target.style.setProperty('display', 'none', 'important');
      target.dataset.unpatchedSimpleeHidden = '1';
    }

    var TIER_DATA = {
      'silver-membership': { short: 'Mud Bogger', entries: '25', duration: '1 month' },
      'gold-membership': { short: 'Rock Crawler', entries: '75', duration: '3 months' },
      'platinum-membership': { short: 'Tourer', entries: '150', duration: '6 months' },
      'annual-membership': { short: 'Off Grid', entries: '250', duration: '1 year' }
    };

    function handleFromUrl(url) {
      try {
        var path = new URL(url, window.location.origin).pathname;
        var parts = path.split('/').filter(Boolean);
        return parts[parts.length - 1] || null;
      } catch (e) {
        return null;
      }
    }

    function applyTier(handle, productData) {
      var tier = TIER_DATA[handle];
      if (!tier) return;

      var titleEl = document.querySelector('.unpatched-pdp__title');
      if (titleEl && productData) titleEl.textContent = productData.title;

      var breadcrumbTitle = document.querySelector('[data-unpatched-breadcrumb-title]');
      if (breadcrumbTitle && productData) {
        breadcrumbTitle.textContent = (productData.title || '').toLowerCase();
      }

      var tierHeading = document.querySelector('[data-unpatched-tier-heading]');
      if (tierHeading) tierHeading.textContent = tier.short;

      var renewalEntries = document.querySelector('[data-unpatched-renewal-entries]');
      if (renewalEntries) renewalEntries.textContent = tier.entries;

      var renewalDuration = document.querySelector('[data-unpatched-renewal-duration]');
      if (renewalDuration) renewalDuration.textContent = tier.duration;

      var priceEl = document.querySelector('.unpatched-pdp__price');
      if (priceEl && productData) {
        priceEl.textContent = '$' + Math.round(productData.price / 100);
      }

      var entriesBadge = document.querySelector('[data-unpatched-entries]');
      if (entriesBadge) entriesBadge.textContent = '+' + tier.entries + ' entries into this draw';

      var tierNameSpan = document.querySelector('[data-unpatched-tier-name]');
      if (tierNameSpan) tierNameSpan.textContent = tier.short;

      document.querySelectorAll('[data-benefit-template]').forEach(function (li) {
        var tmpl = li.dataset.benefitTemplate || '';
        var swapped = tmpl.split('[entries]').join(tier.entries);
        swapped = swapped.split('[duration]').join(tier.duration);
        li.textContent = swapped;
      });

      var heroImg = document.querySelector('.unpatched-pdp__hero-img');
      if (heroImg && productData && productData.featured_image) {
        heroImg.src = productData.featured_image;
        heroImg.srcset = '';
      }

      var variantInput = document.querySelector('[data-unpatched-variant-id]');
      if (variantInput && productData && productData.variants && productData.variants[0]) {
        variantInput.value = productData.variants[0].id;
      }

      var sellingPlanInput = document.querySelector('[data-unpatched-selling-plan]');
      if (productData && productData.sellingPlanId) {
        if (sellingPlanInput) {
          sellingPlanInput.value = productData.sellingPlanId;
        } else {
          var form = document.querySelector('.unpatched-pdp__form');
          if (form) {
            var freshInput = document.createElement('input');
            freshInput.type = 'hidden';
            freshInput.name = 'selling_plan';
            freshInput.value = productData.sellingPlanId;
            freshInput.setAttribute('data-unpatched-selling-plan', '');
            form.appendChild(freshInput);
          }
        }
      }

      var stickyTitle = document.querySelector('.unpatched-pdp__sticky-title');
      if (stickyTitle) stickyTitle.textContent = 'Patched ' + tier.short;
      var stickyPrice = document.querySelector('.unpatched-pdp__sticky-price');
      if (stickyPrice && productData) {
        var cadenceEl = document.querySelector('.unpatched-pdp__cadence');
        var suffix = cadenceEl ? cadenceEl.textContent : '/month';
        stickyPrice.textContent = '$' + Math.round(productData.price / 100) + suffix;
      }

      document.querySelectorAll('.unpatched-pdp__tier-card').forEach(function (c) {
        var cardHandle = handleFromUrl(c.getAttribute('href'));
        if (cardHandle === handle) {
          c.classList.add('unpatched-pdp__tier-card--active');
          c.setAttribute('aria-current', 'true');
        } else {
          c.classList.remove('unpatched-pdp__tier-card--active');
          c.removeAttribute('aria-current');
        }
      });

      if (productData) document.title = productData.title;
    }

    function initTierSwitching() {
      var cards = document.querySelectorAll('.unpatched-pdp__tier-card');
      if (!cards.length) return;

      cards.forEach(function (card) {
        if (card.dataset.unpatchedTierInit) return;
        card.dataset.unpatchedTierInit = '1';

        card.addEventListener('click', function (e) {
          var href = card.getAttribute('href');
          var handle = handleFromUrl(href);
          if (!handle || !TIER_DATA[handle]) return;
          if (handle === handleFromUrl(window.location.href)) {
            e.preventDefault();
            return;
          }
          e.preventDefault();

          var data = buildProductDataFromPreload(handle);
          if (data) {
            applyTier(handle, data);
            history.pushState({ patchedHandle: handle }, '', href);
          } else {
            fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
              .then(function (r) { return r.json(); })
              .then(function (fetched) {
                applyTier(handle, fetched);
                history.pushState({ patchedHandle: handle }, '', href);
              })
              .catch(function () {
                window.location.href = href;
              });
          }
        });
      });

      window.addEventListener('popstate', function () {
        var handle = handleFromUrl(window.location.href);
        if (handle && TIER_DATA[handle]) {
          var data = buildProductDataFromPreload(handle);
          if (data) {
            applyTier(handle, data);
          } else {
            fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
              .then(function (r) { return r.json(); })
              .then(function (fetched) { applyTier(handle, fetched); })
              .catch(function () {});
          }
        }
      });
    }

    function buildProductDataFromPreload(handle) {
      var pre = window.UNPATCHED_TIER_DATA && window.UNPATCHED_TIER_DATA[handle];
      if (!pre) return null;
      return {
        title: pre.title,
        price: pre.priceCents,
        featured_image: pre.image,
        variants: [{ id: pre.variantId }],
        sellingPlanId: pre.sellingPlanId
      };
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    var observer = new MutationObserver(function () {
      hideSimpleeBlock();
    });
    var startObserver = function () {
      if (document.body) {
        observer.observe(document.body, { childList: true, subtree: true });
      } else {
        setTimeout(startObserver, 50);
      }
    };
    startObserver();
  })();

  } catch(e) { console.error(e); }
})();
})();
